// const slider = document.querySelector('.product-gallery--media-thumbnail');
// let isDown = false;
// let startX;
// let scrollLeft;

// slider.addEventListener('mousedown', (e) => {
//   isDown = true;
//   slider.classList.add('active');
//   startX = e.pageX - slider.offsetLeft;
//   scrollLeft = slider.scrollLeft;
// });
// slider.addEventListener('mouseleave', () => {
//   isDown = false;
//   slider.classList.remove('active');
// });
// slider.addEventListener('mouseup', () => {
//   isDown = false;
//   slider.classList.remove('active');
// });
// slider.addEventListener('mousemove', (e) => {
//   if(!isDown) return;
//   e.preventDefault();
//   const x = e.pageX - slider.offsetLeft;
//   const walk = (x - startX) * 3; //scroll-fast
//   slider.scrollLeft = scrollLeft - walk;
//   console.log(walk);
// });

document.addEventListener('click', function(event) {
    if (event.target.closest('.clicktis')) {
        var gridItem = event.target.closest('.productgrid--item').querySelector('.productitem--actions .productitem--action-trigger');
        console.log(gridItem);
        if (gridItem) {
            gridItem.click();
        }
    }
});
const tabItems = document.querySelectorAll('.tab-item');

tabItems.forEach(tabItem => {
    tabItem.addEventListener('click', function() {
        tabItems.forEach(item => item.classList.remove('active'));
        document.querySelectorAll('.tab-detail-item').forEach(content => content.classList.remove('active'));
        document.querySelectorAll('.tab-content').forEach(content => content.classList.remove('active'));
        const targetClass = this.getAttribute('data-target');
        const targetElements = document.querySelectorAll(`.${targetClass}`);
        targetElements.forEach(element => {
            element.classList.add('active');
        });
        this.classList.add('active');
    });
});



$(document).ready(function() {
            var $defaultSection = $('.is-default-tab .featured-collection__content');
            $('.tab-detail-section').not('.is-default-tab').each(function() {
                var $items = $(this).find('.tab-detail-item');
                $items.appendTo($defaultSection);
            });
        });
$(document).ready(function() {
    function updateSoit() {
        var $squareMeterInput = $('.squaremetere-input');
        if ($squareMeterInput.length > 0) {
            var squareMeterValue = parseFloat($squareMeterInput.data('sqmt'));
            var quantity = parseInt($('.quantity-selector__input').val());
            var newSoitValue = squareMeterValue * quantity;
            $squareMeterInput.val((newSoitValue % 1 === 0) ? newSoitValue.toFixed(0) : newSoitValue.toFixed(2));
        }
    }

    // Utilisation de delegation avec on() pour les éléments dynamiques
    $(document).on('input', '.quantity-selector__input', function() {
        updateSoit();
    });

    $(document).on('click', 'button[name="plus"], button[name="minus"]', function() {
        setTimeout(function() {
            updateSoit();
        }, 50);
    });
});


$(document).ready(function() {
    // if (localStorage.getItem('announcementClosed') === 'true') {
    //     $('#announcement').hide();
    // }
    $("#closeAnnouncement").click(function() {
        $("#announcement").hide();
        // Save the state in local storage
        // localStorage.setItem('announcementClosed', 'true');
    });
});


$(document).ready(function() {


$( ".morenav .navmenu-link-depth-1" ).on( "touchstart click", function() {

    var summaryElement = $(this);
    var isExpanded = summaryElement.attr('aria-expanded') === 'true';

    if (isExpanded) {
       $('.site-header-menu-toggle--button').removeClass('active');
        summaryElement.attr('aria-expanded', 'false');
        $('.site-main-dimmer').attr('data-animation-state', 'close');
        $('.navmenu-meganav--desktop[data-animation-state="open"]').attr('data-animation-state', 'close');
    } else {
   $('.site-header-menu-toggle--button').addClass('active');
        summaryElement.attr('aria-expanded', 'true');
         $('.site-main-dimmer').attr('data-animation-state', 'open');
        $('.navmenu-meganav--desktop[data-animation-state="close"]').attr('data-animation-state', 'open');
    }

});


  const $toggleButton = $('.site-header-menu-toggle--button');
$(document).on('click', function(event) {
        if (!$(event.target).closest('.site-header-menu-toggle--button, .navmenu-submenu').length) {
            $toggleButton.removeClass('active');
        }
    });

  $(document).on('click','.ad_to_cart',function(){ 
        var varId = $(this).attr("data-varId"); 
      if ($(this).is(':checked')) {

           
        $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: parseInt(varId)
        },
          dataType: 'json', 
         success: function (data) { 
         location.reload();
         
         } 
         });
      }
    else
      {
            $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          quantity: 0,
          id: parseInt(varId)
        },
          dataType: 'json', 
         success: function (data) { 
         location.reload();
         
         } 
         });
      }
}) 





  $(document).ready(function() {
    // Function to get cart data
    function getCartData() {
        return $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json'
        });
    }

    // Function to remove an item from the cart
    function removeCartItem(line) {
        return $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                line: line,
                quantity: 0
            }
        });
    }

    // Check the cart and remove "pack" items if the condition is met
    getCartData().done(function(cart) {
    
        var onlyPackItems = true;
        var packItemLines = [];

        cart.items.forEach(function(item, index) {
            console.log(item);
            var hasPackTag = item.title.indexOf('PACK') > -1;
            if (!hasPackTag) {
                onlyPackItems = false;
            } else {
                packItemLines.push(index + 1); // Shopify line items are 1-based
            }
        });

        if (onlyPackItems && packItemLines.length > 0) {
            packItemLines.forEach(function(line) {
                removeCartItem(line);
            });
              setTimeout(function() {
               location.reload();
        }, 500);
        
        }
    });


 $(document).on('click', '.cart-item__remove-link', function(event) {
    setTimeout(function() {
               location.reload();
        }, 1000);

   });
    
});

  
   
});





  $(document).ready(function () {
    $(".chat-widget-pop").fadeOut();
    $(".show-chat-widget").on("click", function() {
         $('.chat-pop-phone-content').addClass('initial-hide'); 
         $('.chat-pop-content').show(); 
          $(".chat-widget-pop").fadeIn();
      });
  // Initialize intl-tel-input
  const phoneInputField = document.querySelector("#phone");
  const randomExperts = Math.floor(Math.random() * 20) + 10;   
  const phoneInput = window.intlTelInput(phoneInputField, {
    initialCountry: "fr",
    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
  });


  // Close popup
  $(".close-chat-btn").on("click", function () {
    $(".chat-widget-pop").fadeOut();
  });


    
if (!localStorage.getItem('chatWidgetClosed')) {
    $('.chat-widget-section').show(); // Show the widget only if not closed
  }
    else{
       $('.chat-widget-section').hide();
    }

  checkChatWidgetStatus();
  $('.decline').on('click', function(event) {
    event.preventDefault();
    $('.chat-widget-section').addClass('slide-out');
    setTimeout(function() {
      $('.chat-widget-section').hide();
      localStorage.setItem('chatWidgetClosedTimestamp', Date.now());
    }, 500);
  });

function checkChatWidgetStatus() {
  const closedTimestamp = localStorage.getItem('chatWidgetClosedTimestamp');
  const twoHoursInMilliseconds = 2 * 60 * 60 * 1000; // 2 hours

  if (closedTimestamp && (Date.now() - closedTimestamp < twoHoursInMilliseconds)) {
    // Two hours have not passed yet, keep the widget hidden
    $('.chat-widget-section').hide();
  } else {
    // Two hours have passed or the widget was never closed, show it
    $('.chat-widget-section').show();
  }
}
    
    
    $('.status-bar').text(function(_, currentText) {
        return currentText.replace(/\d+/, randomExperts);
    });


     function validateFields() {
        const phone1 = $.trim($('#phone').val());
        const privacyChecked1 = $('#privacy-checkbox').is(':checked');
        const qualityChecked1 = $('#quality-checkbox').is(':checked');
        if (!phone1) {
          $('#phone-error').show();
        } else {
          $('#phone-error').hide();
        }
        if (!privacyChecked1) {
          $('#privacy-error').show();
        } else {
          $('#privacy-error').hide();
        }
      }


      $('#phone').on('input', validateFields);
      $('#privacy-checkbox').on('change', validateFields);
    
      $('.appointment-btn').on('click', function() {
      const phone = $.trim($('#phone').val());
      const privacyChecked = $('#privacy-checkbox').is(':checked');
      const qualityChecked = $('#quality-checkbox').is(':checked');

      // Check if phone number is not empty
      if (!phone) {
       $('#phone-error').show(); 
          return;
       } else {
          $('#phone-error').hide();
        }

         if (!privacyChecked) {
          $('#privacy-error').show(); 
          return;
        } else {
          $('#privacy-error').hide();
        }
    
      // AJAX request to send data
      $.ajax({
        url: 'https://rentside.website/invoice/contactnumber',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          phone: phone,
          privacyChecked: privacyChecked,
          qualityChecked: qualityChecked
        }),
        success: function(response) {
          if (response.success) {
            $('.chat-pop-phone-content').removeClass('initial-hide'); 
            $('.chat-pop-content').hide(); 
          } else {
             $('.chat-pop-phone-content').addClass('initial-hide'); 
            $('.chat-pop-content').show(); 
          }
        },
        error: function(xhr, status, error) {
          console.error('Error:', error);
          alert('An error occurred. Please try again.');
        }
      });
    });


  $(document).on("click",".cart-checkout button,.cart-title-button",function(e) {
              const $termsCheckbox = $('#terms');
              if (!$termsCheckbox.length || !$termsCheckbox.is(":checked"))
              {
                e.preventDefault();
                $("html, body").animate({ scrollTop: 0 }, "slow");
                $('.checkbox-wrapper-4').addClass('fz-error');
                $('header.cart-title').addClass('fz-btn-error');
                $('.fz-trems-container').append('<div style="color: red;">Veuillez cocher et accepter les CGV</div>');
                $('header.cart-title').after('<div style="color: red;margin-top: 0;text-align: right;justify-content: end;" class="cart-title">Veuillez cocher et accepter les CGV</div>')
              }
            });
    
});
let did = '';
$('.fz-btn-click').on('click',function(e){
  e.preventDefault();
  did = $(this).data('id');
  $('.navmenu-meganav').css('--menu-open-height','100vh');
  $('.fz-more').find('.'+did).css('display','');
  $('.fz-more').find('span.'+did).css('display','');
  $('.fzmulti').css('transform','translateX(-100vw)');
})
$('.fz-btn-back').on('click',function(){
  $('.fzmulti').css('transform','translateX(0)');
  $('.navmenu-meganav').each(function() {
  this.style.removeProperty('--menu-open-height');
});
  $('.fz-more').find('.'+did).css('display','none');
  $('.fz-more').find('span.'+did).css('display','none');
})

function isInViewport($el) {
  const rect = $el[0].getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom > 0;
}

$(document).on('scroll', function () {
  const $atcButton = $('.product-form__action-wrapper .product-form--atc-button');
  if ($atcButton.length === 0) return;

  if (isInViewport($atcButton)) {
    $('body').addClass('fz-button-inView').removeClass('fz-button-notInView');
  } else {
    $('body').addClass('fz-button-notInView').removeClass('fz-button-inView');
  }
});



$('.fz-ttt').on('click',function(e){
  $('.product-form__action-wrapper .product-form--atc-button').submit();
})


document.querySelectorAll('.mobile-show [name="plus"], .mobile-show [name="minus"]')
  .forEach(button => {
    button.addEventListener('click', function (event) {
      let wrapper = event.target.closest('.quantity-selector__wrapper');
      let inputEl = wrapper.querySelector('input');
      let v = parseInt(inputEl.value, 10) || 0;

      if (event.target.name === "plus") {
        v++;
      } else if (event.target.name === "minus" && v > 1) {
        v--;
      }

      // Update visible input
      inputEl.value = v;

      // Update hidden product form input
      let productFormInput = document.querySelector('.product-form--atc input[name="quantity"]');
      if (productFormInput) {
        productFormInput.value = v;
      }

      // Only toggle minus button state
      let minusBtn = wrapper.querySelector('[name="minus"]');
      if (minusBtn) {
        let minusWrapper = minusBtn.closest('.quantity-selector__button-wrapper');
        if (minusWrapper) {
          if (v <= 1) {
            minusWrapper.classList.add('quantity-selector__button-wrapper--disabled');
          } else {
            minusWrapper.classList.remove('quantity-selector__button-wrapper--disabled');
          }
        }
      }
    });
  });





const openBtn = document.getElementById('fzopenPopup');
const closeBtn = document.getElementById('fzclosePopup');
const overlay = document.getElementById('fzpopupOverlay');
const popup = document.querySelector('.fzpopup'); // add class to popup box

// Open popup
openBtn.addEventListener('click', () => {
  overlay.style.display = 'flex';
  popup.classList.remove('hide');
});

// Close popup function (with fadeOut)
function closePopup() {
  popup.classList.add('hide'); // start fadeOut

  setTimeout(() => {
    overlay.style.display = 'none';
  }, 300); // match animation time
}

closeBtn.addEventListener('click', closePopup);

// Close when clicking outside popup
overlay.addEventListener('click', (e) => {
  if (e.target === overlay) {
    closePopup();
  }
});
